import { useParams } from 'react-router-dom';
import moment from 'moment';
import { Box } from '@chakra-ui/react';

import useGetOperatorBreaks from 'Domain/report-attendance-operator-detail/useGetOperatorBreaks';
import useGetOperatorViolations from 'Domain/report-attendance-operator-detail/useGetOperatorViolations';
import { useUserInfo } from 'Store/userInfo';

import ReportAttendanceOperatorDetailProvider, { useReportAttendanceOperatorDetailState } from 'View/report-attendance-operator-detail/state';
import Head from 'View/report-attendance-operator-detail/section/head';
import Tab from 'View/report-attendance-operator-detail/section/tab';
import Table from 'View/report-attendance-operator-detail/section/table';

import styles from './styles.module.css';

const ReportAttendanceOperatorDetail = () => {
  const params = useParams();
  const { id, date } = params;
  const { userId } = useUserInfo();
  const paramsDate = moment(date, 'DD-MM-YYYY');
  const { selectedTab, filterState } = useReportAttendanceOperatorDetailState();

  const filterParams = { filter: { ...filterState, paramsDate, operatorId: id || userId }, selectedTab };

  const { data: dataBreaks, isFetching: isFetchingBreak } = useGetOperatorBreaks(filterParams);
  const { data: dataViolations, isFetching: isFetchingViolation } = useGetOperatorViolations(filterParams);
  const data = selectedTab === 'restViolation' ? dataBreaks : dataViolations;
  const isFetching = selectedTab === 'restViolation' ? isFetchingBreak : isFetchingViolation;

  return (
    <Box className={styles['attendance-report__container']}>
      <Head data={data} isFetching={isFetching} />
      <Tab isFetching={isFetching} />
      <Table data={data} isFetching={isFetching} />
    </Box>
  );
};

const ReportAttendanceOperatorDetailContainer = () => {
  return (
    <ReportAttendanceOperatorDetailProvider>
      <ReportAttendanceOperatorDetail />
    </ReportAttendanceOperatorDetailProvider>
  );
};

export default ReportAttendanceOperatorDetailContainer;
